import React, { useState, useEffect } from "react";
// 假设你的 service、model、类型定义等路径和命名如下，若实际不同请自行替换
import { externalBillService } from "../externalBillService";
import { useExternalBillModel } from "../externalBillModel";
import { momentFormat } from '@/utils/utils';
import useGlobalModel from "@/model/globalModel";

interface PropsType {
    completedPrintVisible: boolean;
    setCompletedPrintVisible: (visible: boolean) => void;

}

export const CompletedPrintTable = (props: PropsType) => {
    const { completedPrintVisible, setCompletedPrintVisible } = props;
    const { descRows, selectedRowKeys } = useExternalBillModel(); // 若用不到可考虑删除或调整
    const [printData, setPrintData] = useState<any>({});

    useEffect(() => {
        if (completedPrintVisible) {
            externalBillService.one((selectedRowKeys[0] as string)).then(({ retData }) => {
                let newForm = retData.vrmExternalSends.find((item: any) => item.checked === 1)
                let newData = {
                    ...retData,
                    createTime: momentFormat(retData.createTime),
                    isTransport: retData.isTransport === 0 ? "是" : "否",
                    oldPartConfirm: retData.oldPartConfirm === 0 ? "是" : "否",
                    backTime: momentFormat(retData.backTime),
                    checkTime: momentFormat(retData.checkTime),
                    ...newForm
                };
                setPrintData({ ...newData });
                print();
            })

        }
    }, [completedPrintVisible]);
    const { CustomerData, shopAndOrg: { shopName, shopId } } = useGlobalModel()
    const print = () => {
        const el: HTMLElement | null = document.getElementById('completedPrint-container');
        const iframe: HTMLIFrameElement = document.createElement('iframe');
        document.body.appendChild(iframe);

        const doc = iframe.contentWindow?.document;
        if (doc) {
            doc.open();
            // 引入打印样式，若有专属的接车单样式可替换路径
            doc.write('<link rel="stylesheet" type="text/css" href="./offerPrint.css">');
            doc.write(el?.innerHTML || '');
            doc.close();
        }

        iframe.contentWindow?.addEventListener('afterprint', () => {
            document.body.removeChild(iframe);
            setCompletedPrintVisible(false);
        });

        iframe.contentWindow?.focus();
        iframe.onload = () => {
            iframe.contentWindow?.print();
        };

        if (navigator.userAgent.indexOf("MSIE") > 0) {
            setTimeout(() => {
                document.body.removeChild(iframe);
            }, 100);
        }
    };

    return (
        <div style={{ display: 'none' }}>
            <div id="completedPrint-container" className="offerPrint-container">
                <div className="print-page">
                    <div style={{ textAlign: 'center', fontSize: 24, fontFamily: "FangSong", margin: "40px 0px 15px 0", fontWeight: 'bold' }}>
                        {`${shopName}车辆外修竣工单`}
                    </div>
                    <table className="mingxi" style={{ border: "1px solid black", width: '100%', borderCollapse: 'collapse' }}>
                        <tbody>
                            <tr style={{ lineHeight: 3 }}>
                                <td style={{ width: '20%', fontSize: 16, fontFamily: "FangSong", fontWeight: 'normal', border: '1px solid black', textAlign: 'center' }}>外修编号</td>
                                <td colSpan={3} style={{ fontSize: 16, fontFamily: "FangSong", fontWeight: 'normal', border: '1px solid black' }}>{printData.code}</td>
                            </tr>
                            <tr style={{ lineHeight: 3 }}>
                                <td style={{ width: '20%', fontSize: 16, fontFamily: "FangSong", fontWeight: 'normal', border: '1px solid black', textAlign: 'center' }}>申请站点</td>
                                <td style={{ width: '30%', fontSize: 16, fontFamily: "FangSong", fontWeight: 'normal', border: '1px solid black' }}>{printData.shopName}</td>
                                <td style={{ width: '20%', fontSize: 16, fontFamily: "FangSong", fontWeight: 'normal', border: '1px solid black', textAlign: 'center' }}>报修人</td>
                                <td style={{ width: '30%', fontSize: 16, fontFamily: "FangSong", fontWeight: 'normal', border: '1px solid black' }}>{printData.contact}</td>
                            </tr>
                            <tr style={{ lineHeight: 3 }}>
                                <td style={{ width: '20%', fontSize: 16, fontFamily: "FangSong", fontWeight: 'normal', border: '1px solid black', textAlign: 'center' }}>车辆所属单位</td>
                                <td style={{ width: '30%', fontSize: 16, fontFamily: "FangSong", fontWeight: 'normal', border: '1px solid black' }}>{printData.customerName}</td>
                                <td style={{ width: '20%', fontSize: 16, fontFamily: "FangSong", fontWeight: 'normal', border: '1px solid black', textAlign: 'center' }}>车牌号</td>
                                <td style={{ width: '30%', fontSize: 16, fontFamily: "FangSong", fontWeight: 'normal', border: '1px solid black' }}>{printData.licensePlate}</td>
                            </tr>
                            <tr style={{ lineHeight: 3 }}>
                                <td style={{ width: '20%', fontSize: 16, fontFamily: "FangSong", fontWeight: 'normal', border: '1px solid black', textAlign: 'center' }}>车辆类型</td>
                                <td style={{ width: '30%', fontSize: 16, fontFamily: "FangSong", fontWeight: 'normal', border: '1px solid black' }}>{printData.vehicleTypeName}</td>
                                <td style={{ width: '20%', fontSize: 16, fontFamily: "FangSong", fontWeight: 'normal', border: '1px solid black', textAlign: 'center' }}>行驶公里数</td>
                                <td style={{ width: '30%', fontSize: 16, fontFamily: "FangSong", fontWeight: 'normal', border: '1px solid black' }}>{printData.mileage}</td>
                            </tr>
                            <tr style={{ lineHeight: 3 }}>
                                <td style={{ width: '20%', fontSize: 16, fontFamily: "FangSong", fontWeight: 'normal', border: '1px solid black', textAlign: 'center' }}>维修单位名称</td>
                                <td colSpan={3} style={{ fontSize: 16, fontFamily: "FangSong", fontWeight: 'normal', border: '1px solid black' }}>{printData.supplierName}</td>
                            </tr>
                            <tr style={{ lineHeight: 3 }}>
                                <td style={{ width: '20%', fontSize: 16, fontFamily: "FangSong", fontWeight: 'normal', border: '1px solid black', textAlign: 'center' }}>报修内容</td>
                                <td colSpan={3} style={{ fontSize: 16, fontFamily: "FangSong", fontWeight: 'normal', border: '1px solid black' }}>{printData.faultDesc}</td>
                            </tr>
                            <tr style={{ lineHeight: 4 }}>
                                <td style={{ width: '20%', fontSize: 16, fontFamily: "FangSong", fontWeight: 'normal', border: '1px solid black', textAlign: 'center' }}>维修内容</td>
                                <td colSpan={3} style={{ fontSize: 16, fontFamily: "FangSong", fontWeight: 'normal', border: '1px solid black' }}>{printData.itemNote}</td>

                            </tr>
                            <tr style={{ lineHeight: 4 }}>
                                <td style={{ width: '20%', fontSize: 16, fontFamily: "FangSong", fontWeight: 'normal', border: '1px solid black', textAlign: 'center' }}>更换配件</td>
                                <td colSpan={3} style={{ fontSize: 16, fontFamily: "FangSong", fontWeight: 'normal', border: '1px solid black' }}>{printData.materialNote}</td>

                            </tr>
                            <tr style={{ lineHeight: 3 }}>
                                <td style={{ width: '20%', fontSize: 16, fontFamily: "FangSong", fontWeight: 'normal', border: '1px solid black', textAlign: 'center' }}>旧件确认返还</td>
                                <td style={{ width: '30%', fontSize: 16, fontFamily: "FangSong", fontWeight: 'normal', border: '1px solid black' }}>{printData.oldPartConfirm == 0 ? '是' : '否'}</td>
                                <td colSpan={2} style={{ fontSize: 16, fontFamily: "FangSong", fontWeight: 'normal', border: '1px solid black', }}>&nbsp;&nbsp;情况说明：{printData.oldPartConfirmNote}</td>
                            </tr>
                            <tr style={{ lineHeight: 3 }}>
                                <td style={{ width: '20%', fontSize: 16, fontFamily: "FangSong", fontWeight: 'normal', border: '1px solid black', textAlign: 'center' }}>回厂时间</td>
                                <td style={{ width: '30%', fontSize: 16, fontFamily: "FangSong", fontWeight: 'normal', border: '1px solid black' }}>{printData.backTime}</td>
                                <td style={{ width: '20%', fontSize: 16, fontFamily: "FangSong", fontWeight: 'normal', border: '1px solid black', textAlign: 'center' }}>外修厂签字</td>
                                <td style={{ width: '30%', fontSize: 16, fontFamily: "FangSong", fontWeight: 'normal', border: '1px solid black' }}></td>
                            </tr>
                            <tr style={{ lineHeight: 3 }}>
                                <td style={{ width: '20%', fontSize: 16, fontFamily: "FangSong", fontWeight: 'normal', border: '1px solid black', textAlign: 'center' }}>验收日期</td>
                                <td style={{ width: '30%', fontSize: 16, fontFamily: "FangSong", fontWeight: 'normal', border: '1px solid black' }}>{printData.checkTime}</td>
                                <td style={{ width: '20%', fontSize: 16, fontFamily: "FangSong", fontWeight: 'normal', border: '1px solid black', textAlign: 'center' }}>验收人</td>
                                <td style={{ width: '30%', fontSize: 16, fontFamily: "FangSong", fontWeight: 'normal', border: '1px solid black' }}>{printData.checkUser}</td>
                            </tr>
                            <tr style={{ lineHeight: 3 }}>
                                <td style={{ width: '20%', fontSize: 16, fontFamily: "FangSong", fontWeight: 'normal', border: '1px solid black', textAlign: 'center' }}>对接验收人</td>
                                <td colSpan={3} style={{ fontSize: 16, fontFamily: "FangSong", fontWeight: 'normal', border: '1px solid black', position: 'relative', }}>
                                    <div style={{ position: 'absolute', bottom: '5px', left: '5px', fontSize: 14 }}>
                                        签名：
                                    </div>
                                    <div style={{ position: 'absolute', bottom: '5px', right: '5px', fontSize: 14 }}>
                                        年&nbsp;&nbsp;&nbsp;月&nbsp;&nbsp;&nbsp;日
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div >
    );
};